import { createApp } from "vue";
import * as Sentry from "@sentry/vue";

import API from "@/api/api";
import { router } from "@/router";
import { FilterUtils } from "@/filters";

import Storage from "@/plugins/storage";
import WS from "@/plugins/ws.connection";
import i18n from "@/plugins/i18n";
import vuetify from "@/plugins/vuetify";
import dayjs from "@/plugins/dayjs";
import { plugin as EqualHeights } from "@morev/equal-heights/vue";

import "@vuepic/vue-datepicker/dist/main.css";

import "@/assets/style/fonts.css";
import "@/assets/style/color.scss";
import "@/assets/style/buttons.scss";
import "@/assets/style/style.scss";

import clipboard from "@/directives/clipboard";
import vPhone from "@/directives/phone.ts";

import App from "@/App.vue";
import CabinetLayout from "@/views/layout/Cabinet.vue";
import BlankLayout from "@/views/layout/Blank.vue";
import { vMaska } from "maska";
import VueDatePicker from "@vuepic/vue-datepicker";
import { createPinia } from "pinia";

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);

app.config.globalProperties.$filters = new FilterUtils();

app.component("CabinetLayout", CabinetLayout);
app.component("BlankLayout", BlankLayout);
app.component("VueDatePicker", VueDatePicker);

app.directive("clipboard", clipboard);
app.directive("maska", vMaska);
app.directive("phone", vPhone);

app.use(vuetify);
app.use(router);
app.use(i18n);
app.use(dayjs);
app.use(EqualHeights);

app.use(API);
app.use(Storage);
app.use(WS);

// Initialize Sentry based on environment
const env = import.meta.env;
if (env.VITE_APP_ENV === "production" || env.VITE_APP_ENV === "staging") {
  Sentry.init({
    app,
    dsn: env.VITE_SENTRY_DSN,
    tracePropagationTargets: env.VITE_TRACE_TARGETS.split(","),
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
      Sentry.replayCanvasIntegration({
        enableManualSnapshot: true,
      }),
    ],
    tracesSampleRate: env.VITE_TRACES_SAMPLE_RATE,
    replaysOnErrorSampleRate: env.VITE_REPLAYS_SAMPLE_RATE,
    environment: env.VITE_SENTRY_ENV,
  });
}

router.isReady().then(() => {
  app.mount("#app");
});
